import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosAPI from "../../api/axiosAPI";

//============ add offer ===================//
export const addOffer = createAsyncThunk("addOffer", async (data) => {
    try {
        const response = await axiosAPI.post("/add-offer", data)
        return response
    } catch (err) {
        return err
    }
})

//========= Get all offer with pagination ================//
export const getAllOffer = createAsyncThunk("getAllOffer", async ({ page, limit, search }) => {
    try {
        const response = await axiosAPI.get(`/get-all-offer?page=${page}&limit=${limit}&search=${search}`);
        return response;
    } catch (err) {
        return err
    }
});

//============ Get all offer count ===================//
export const getAllOfferCount = createAsyncThunk("getAllOfferCount", async () => {
    try {
        const response = await axiosAPI.get("/all-offer-count");
        return response;
    } catch (err) {
        return err
    }
});

//============ Get all inactive offer ===================//
export const getInActiveOffer = createAsyncThunk("getInActiveOffer", async () => {
    try {
        const response = await axiosAPI.get("/get-inactive-offer");
        return response;
    } catch (err) {
        return err
    }
});

//============ Get all active offer ===================//
export const getActiveOffer = createAsyncThunk("getActiveOffer", async () => {
    try {
        const response = await axiosAPI.get("/get-active-offer");
        return response;
    } catch (err) {
        return err
    }
});

//============== Toggle offer status ==============//
export const toggleOfferStatus = createAsyncThunk("toggleOfferStatus", async (data) => {
    try {
        const { id } = data;
        const response = await axiosAPI.put(`/toggle-offer-status/${id}`);
        return response;
    } catch (err) {
        return err
    }
})

//============ Get single offer ===================//
export const getOffer = createAsyncThunk("getOffer", async (id) => {
    try {
        const response = await axiosAPI.get(`/get-offer/${id}`);
        return response;
    } catch (err) {
        return err
    }
});

//=============== update offer =================//
export const updateOffer = createAsyncThunk("updateOffer", async (data) => {
    try {
        const { id, values } = data;
        const response = await axiosAPI.put(`/update-offer/${id}`, values);
        return response
    } catch (err) {
        return err
    }
})